/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';

import CardSuccess from 'components/CardSuccess';
import {
  showExternalHeader,
  showInternalHeader,
  updateAriaLiveMessage,
} from 'actions/ui';
import { isAuthenticatedSelector } from 'store/selectors';
import { CHANGE_EMAIL_SUCCESS_TITLE } from 'constants/pageTitles';
import {
  CORREO_CREADO_EXITOSAMENTE,
  REVISA_CORREO_Y_SEGURIDAD,
  IR_A_CONFIGURACION_DE_SEGURIDAD,
  VOLVER_AL_A_MI_CUENTA,
} from 'constants/commonConstants';
import { SEGURIDAD_ROUTE, AUTOGESTION_IDP } from 'constants/RouterConstants';
import ButtonLink from '../../components/ButtonLink';

const CambioEmailValidatedContainer = () => {
  const dispatch = useDispatch();
  const estaAutenticado = useSelector(isAuthenticatedSelector);

  useEffect(() => {
    dispatch(showExternalHeader());
    dispatch(updateAriaLiveMessage(CHANGE_EMAIL_SUCCESS_TITLE));
    return () => {
      if (estaAutenticado) {
        dispatch(showInternalHeader());
      }
    };
  }, []);

  return (
    <>
      <Helmet title={CHANGE_EMAIL_SUCCESS_TITLE} />
      <CardSuccess
        title={CORREO_CREADO_EXITOSAMENTE}
        description={REVISA_CORREO_Y_SEGURIDAD}
        returnUrl={SEGURIDAD_ROUTE}
        headerText={IR_A_CONFIGURACION_DE_SEGURIDAD}
        extra1={
          <ButtonLink
            buttonType="header"
            to={AUTOGESTION_IDP}
            aria-label={VOLVER_AL_A_MI_CUENTA}
            title={VOLVER_AL_A_MI_CUENTA}
          />
        }
      />
    </>
  );
};

export default CambioEmailValidatedContainer;
